import { render } from "./CardClientSite.vue?vue&type=template&id=01fbafac"
import script from "./CardClientSite.vue?vue&type=script&lang=js"
export * from "./CardClientSite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__